import { Box, Flex, Tooltip } from '@chakra-ui/react';
import { AddSquareIcon, InfoIcon, SubtractSquareIcon } from '../icons';
import { createColumnHelper } from '@tanstack/react-table';
import GoalDetails from './GoalDetails';
import { GoalsColumnCell } from './GoalsColumnCell';
import { ScopeColumnCell } from './ScopeColumnCell';
import { ProgressColumnCell } from './ProgressColumnCell';
import { ThresholdField } from './types';

const columnHelper = createColumnHelper<any>();

export const columns = (thresholdData: ThresholdField | undefined) => [
  columnHelper.accessor('expander', {
    header: () => null,
    size: 20,
    enableSorting: false,
    cell: ({ row }) => {
      return row.getCanExpand() ? (
        <Box
          maxWidth="200px"
          paddingLeft={row.depth === 0 ? 0 : `${6 + row.depth * 14}px`}
        >
          <button
            {...{
              onClick: row.getToggleExpandedHandler(),
              style: { cursor: 'pointer' },
            }}
          >
            {row.getIsExpanded() ? (
              <SubtractSquareIcon height="16" width="16" />
            ) : (
              <AddSquareIcon height="16" width="16" />
            )}
          </button>
          {row.getIsExpanded() && (
            <Box
              position="absolute"
              top="31px"
              left="31.5px"
              width="1px"
              height="100%"
              bg="text.secondary2"
              zIndex={1}
            />
          )}
        </Box>
      ) : (
        <></>
      );
    },
  }),

  columnHelper.accessor('Goals', {
    cell: (info) => <GoalsColumnCell data={info?.row?.original} />,
    header: 'Goals',
    enableSorting: false,
    size: 264,
  }),
  columnHelper.accessor('Scope', {
    cell: (info) => (
      <ScopeColumnCell
        data={info?.row?.original?.associatedIds}
        scope={info?.row?.original?.scope}
        title={info?.row?.original?.title}
      />
    ),
    header: () => (
      <Flex align="center" gap={1}>
        Scope
        <Tooltip
          label="Scope helps define who is primarily responsible for this goal."
          placement="top"
          hasArrow
        >
          <Box>
            <InfoIcon />
          </Box>
        </Tooltip>
      </Flex>
    ),
    size: 136,
    enableSorting: false,
  }),
  columnHelper.accessor('progress', {
    cell: (info) => (
      <ProgressColumnCell
        data={info?.row?.original?.progress}
        thresholdData={thresholdData}
      />
    ),
    header: () => (
      <Flex align="center" gap={1}>
        Progress
        <Tooltip
          label="Overall progress of a Goal, calculated by the weighted average of its Key Result's success rates. KR weights must total 100%. This single percentage helps you quickly assess whether the Objective is on track.Goal/KR Progress levels (On Track, Behind, At Risk) are based on org-wide settings."
          placement="top"
          hasArrow
        >
          <Box>
            <InfoIcon />
          </Box>
        </Tooltip>
      </Flex>
    ),
    enableSorting: false,
    size: 300,
  }),
  columnHelper.accessor('keyResults', {
    cell: (info) => (
      <GoalDetails
        data={info?.row?.original?.keyResultStatusData}
        title="Key Results"
      />
    ),
    header: () => (
      <Flex align="center" gap={1}>
        Key Results
        <Tooltip
          label="Measures how often a Key Result's target was met within its timeframe. E.g., if a KR met its target in 4 out of 5 months, its success is 80%. This shows the consistency of achieving a specific outcome. Goal/KR Progress levels (On Track, Behind, At Risk) are based on org-wide settings."
          placement="top"
          hasArrow
        >
          <Box>
            <InfoIcon />
          </Box>
        </Tooltip>
      </Flex>
    ),
    enableSorting: false,
    size: 300,
  }),
];
